/* eslint-disable react/jsx-no-target-blank */
import React, { useState, useEffect } from 'react' // remeber this is just an alias... not _actually_ using react
import axios from 'axios'
import QueryString from 'qs'

import {
	GlobalStyles,
	Headline,
	InnerWrap,
	OfferCard,
	OfferIntroText,
	OfferList,
	OfferLogo,
	OfferPartnerName,
	PoweredByWrapper,
	SubHeadline,
	VisitOfferButton,
	Wrapper,
} from './style'

import { PoweredByBdcLogo } from './PoweredByBDC'

/**
 * this is the api function to get the data from the backend
 * @param {string} pubId the id representing the QT publisher
 * @param {string} offerGroup the nanme representing the current group of offer cards
 * @returns {object} offerData the data that corresponds to the combination of pubId and offerGroup requested
 */
async function getData(pubId, offerGroup) {
	// this gets populated by the webpack.Define plugin see preact.config.js
	// eslint-disable-next-line no-undef
	const response = await axios.get(`https://${RFQ_API_ENV}.buyerzone.com/v1/qt/${pubId}/${offerGroup}`)

	return response.data.offerGroups[0]
}

// get params from query string
const { pubId = '', offerGroup = '', widgetHostPage = '' } =
	typeof window !== 'undefined' ? QueryString.parse(window.location.search, { ignoreQueryPrefix: true }) : {}

/**
 * create additional queryString param to pass through widget locaiton to HasOffers link,
 *
 * @param {string} object.link
 * @param {string} object.widgetHostPage
 * @param {number} object.rank
 */
function generateLinkWithAddedParams({ link, widgetHostPage, rank }) {
	const additionalQueryStringParams = QueryString.stringify(
		{
			aff_sub2: encodeURIComponent(widgetHostPage || document.referrer), // falling back to document.referrer (which should always be the page serving the iframe widget)
			aff_sub5: `pos|bbc${rank}`,
		},
		{ encode: false, indices: false }
	)

	return `${link}&${additionalQueryStringParams}`
}

export default function QtWidget() {
	const [data, setData] = useState({})

	useEffect(() => {
		;(async function init() {
			const data = await getData(pubId, offerGroup)
			setData(data)
		})()
	}, [])

	const { headline = '...Loading Offers...', subHeadline, offerList } = data

	return (
		<Wrapper>
			<GlobalStyles />
			<Headline>{headline}</Headline>
			<SubHeadline>{subHeadline}</SubHeadline>
			<OfferList>
				{offerList &&
					!!offerList.length &&
					offerList.map(({ partnerName, introText, logo, link }, index) => {
						const linkWithReferrer = generateLinkWithAddedParams({ link, widgetHostPage, rank: index + 1 })
						return (
							<OfferCard>
								<a href={linkWithReferrer} target="_blank" rel="sponsored nofollow noopener">
									<OfferLogo src={logo} alt={`${partnerName} logo`} />
								</a>
								<InnerWrap>
									<OfferPartnerName>{partnerName}</OfferPartnerName>
									<OfferIntroText>{introText}</OfferIntroText>
								</InnerWrap>
								<VisitOfferButton
									href={linkWithReferrer}
									target="_blank"
									rel="sponsored nofollow noopener"
								>
									Visit Site
								</VisitOfferButton>
							</OfferCard>
						)
					})}
			</OfferList>
			<PoweredByWrapper>
				<PoweredByBdcLogo width={175} height={16} />
			</PoweredByWrapper>
		</Wrapper>
	)
}
